var React = require('react');

function SmallMultiply (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 7"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"shape/cross","transform":"translate(0.000000, 1.000000)","stroke":"#309E7A","strokeWidth":"6"},React.createElement("g",{"id":"Group-7","transform":"translate(2.000000, 2.000000)"},[React.createElement("path",{"d":"M27.8815949,0.0967168723 L0.0669030067,28","id":"Path-11","key":0}),React.createElement("path",{"d":"M0.268364221,0.0141032807 L27.902369,28","id":"Path-13","key":1})])))]);
}

SmallMultiply.defaultProps = {"width":"32px","height":"34px","viewBox":"0 0 32 34","version":"1.1"};

module.exports = SmallMultiply;

SmallMultiply.default = SmallMultiply;
